import type { ArticleBody } from './types';
import { CONDITIONS_HI } from './conditions.hi';
import { GUIDES_HI } from './guides.hi';
import { SITUATIONS_HI } from './situations.hi';

export const ARTICLES_HI: Record<string, ArticleBody> = { ...CONDITIONS_HI, ...SITUATIONS_HI, ...GUIDES_HI };
